import React from "react";

const HomeSections = () => {
  return (
    <>
      <section className="comnpadding we_are">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="text-center headingdiv">
                <h2 className="comnheading we-are-title">
                   <span>WE ARE Everywhere!</span>
                </h2>
                <p className="we-are-subtitle">
                  Any place in India you can get services from Trust service
                  providers!{" "}
                </p>
              </div>
              <div className="appdiv">
                <a
                  href="https://play.google.com/store/apps/details?id=com.trustapp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../assets/images/play-store.png")}
                    alt="Play Store"
                  />
                </a>
                <a
                  href="https://itunes.apple.com/us/app/apple-store/id1479704788?mt=8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../assets/images/apple-app-store.png")}
                    alt="Apple App Store"
                  />
                </a>
              </div>
              <p className="we-are-footnote">
                <strong>
                  *To list your business, bid services, and booking services,
                  please use our Android 🙂
                  iOS and website version will be updated very soon!&nbsp;
                </strong>
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="logodiv">
                <div className="text-center headingdiv">
                  <h2 className="comnheading proud-part-title">
                    WE ARE NOW <span className="proud-part-accent">PROUDLY </span>PART OF
                  </h2>
                </div>
                <ul className="list-unstyled">
                  <li>
                    <a href="">
                      <img
                        src={require("../assets/images/part-1.png")}
                        alt="Part 1"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img
                        src={require("../assets/images/part-2.webp")}
                        alt="Part 2"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img
                        src={require("../assets/images/part-3.png")}
                        alt="Part 3"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img
                        src={require("../assets/images/part-4.png")}
                        alt="Part 4"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img
                        src={require("../assets/images/part-5.png")}
                        alt="Part 5"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img
                        src={require("../assets/images/awsactivate.png")}
                        alt="AWS Activate"
                      />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img
                        src={require("../assets/images/apc.png")}
                        alt="APC"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="follow-together">
        <div className="container">
          <div className="follow-together-row">
            <div className="follow-us-part">
              <span className="follow-title">FOLLOW US ON:</span>
              <div className="social-inline">
                <a
                  href="https://www.facebook.com/trust.cloudai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fab fa-facebook fbbg"
                ></a>
                <a
                  href="https://www.instagram.com/trust_app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fab fa-instagram twbgInsta"
                ></a>
                <a
                  href="https://www.youtube.com/playlist?list=PLGPpgDt6rdY99nCCp3eSSMCpYtSS7ZiwE"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fab fa-youtube twbgYoutube"
                ></a>
                <a
                  href="https://twitter.com/trust__app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fab fa-twitter twbg"
                ></a>
                <a
                  href="https://www.linkedin.com/company/trust-mobile-app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fab fa-linkedin inbg"
                ></a>
              </div>
            </div>
            <div className="together-part">
              <h3>Let's make a Trusted service network, together!</h3>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeSections;
